import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../dto/api-response.response';
import { PaymentMethodResponse } from '../dto/payment-method.response';

@Injectable({ providedIn: 'root' })
export class PaymentMethodService {

    private readonly baseUrl = `${environment.apiUrl}/payment-methods`;

    constructor(private http: HttpClient) {}

    getAll(): Observable<ApiResponse<PaymentMethodResponse[]>> {
        return this.http.get<ApiResponse<PaymentMethodResponse[]>>(this.baseUrl);
    }
}
